import React, { useEffect, useState } from "react";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import Timeline from "@mui/lab/Timeline";
import TimelineItem, { timelineItemClasses } from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";

export default function Experience() {
  const [experience, setExperience] = useState([]);
  const data = [
    {
      company: "MMIT",
      position: "Senior Software Engineer",
      descriptoin: "",
      list: [
        "Built and maintain web applications that run in Veeva CRM (CLM Presentations and Html Reports/X-Pages) written in React.js. Applications retrieved data from Salesforce through Veeva's Javascript libraries and proprietary REST APIs.",
        "Leading efforts to port web applications for VaultCRM.",
        "Support new features and fix bugs in proprietary APIs which deliver real world data (e.g., Market Access data and TRx claims data). APIs supported are built on development frameworks .NET Framework 4.6.2 through .NET 8.",
        "Lead a multiple efforts implementing Azure functions (HTTP and Blob trigger) from development to deployment (utilized Azure Configuration Service, KeyVault, Redis cache). Processed files dropped in blob storage (Blog trigger events); normalized data; stored in Redis cache; and returned data through Restful endpoints (HTTP triggers).",
        "Work directly with product owners and stakeholders to design and plan new features",
        "Work directly with client support team to troubleshoot and fix bugs.",
        "Team operates on agile project management methodologies.",
        "Conduct and participate in collaborative code reviews",
      ],
      start: "",
      end: "",
    },
    {
      company: "Music Choice",
      position: "Staff Software Engineer - Cloud Services",
      descriptoin: "",
      list: [
        "Lead Developer in modernizing classic cloud applications. Upgrading applications and library packages from .NET Framework and Standard 2.0 to .NET6. Building REST APIs. Logging and metrics with Application Insights. Created alerts and notifications (emails/MS Teams).",
        "Azure DevOps for CI/CD: Build pipelines for compiling projects; running unit tests; creating/pushing nuget packages; build/push docker images. Release pipelines to deploy to different environments and deployment slots with approval processes.",
        "Implemented Microsoft Authentication Library (MSAL) to use Office365 accounts and leverage roles for access to applications. MSAL implemented in SPA and asp.net web API to require authorization for SPA pages and API.",
        "Technical Writing: Created numerous documents and diagrams to help team members troubleshoot unfamiliar systems. ",
        "Working along side Principal Architects planning company's future systems architecture.",
        "Knowledge share and mentoring of developers on design patterns; performance improvements; C# language features.",
        "Additional Experience: Azure Functions; Event Hub/Grid, Service Bus, CosmosDB, Power Automate],",
      ],
      start: "",
      end: "",
    },
    {
      company: "Music Choice",
      position: "Staff Software Engineer",
      descriptoin: "",
      list: [
        "Longer term project plans and strategies.",
        "Researched and introduced Proxmox to host Linux Containers (LXCs) and reduced license costs produced by Windows servers. Configured Proxmox servers and generated reusable LXC templates.",
        "Introduced near real-time metrics with Prometheus and Grafana. Reduced down time by detecting issues earlier.",
        "Identified storage performance issues and worked with IT team to implement high performance storage solution.",
      ],
      start: "",
      end: "",
    },
    {
      company: "Music Choice",
      position: "Senior Application Developer",
      descriptoin: "",
      list: [
        "Built developer team dashboard that interfaced with REST APIs, WCFs, databases and caches to streamline support tasks. Saved the team hours in support work.",
        "Led team in migrating all supported solutions from a locally managed SVN version control system to Azure Repos.",
        "Introduced RabbitMQ HA cluster as a replacement to MS Service Bus.",
        "Built .NET Core and Node message driven micro-services which reduce load on servers and increased processing time by eliminating contention on resources. Resulted in more reliable system behavior.",
        "Built data-driven Node application headless browser (Puppeteer) for high performance web rendering and image generation.",
        "Designed, deployed, documented, and maintained high performing web rendering application generating hundreds of thousands of images daily. Written in Node using Puppeteer (chromium) as the web driver. Message queue driven. Distributed across dozens of LXCs; easily scalable.",
        "Designed deployed, documented, and maintained multiple high performance multi-threaded Socket processors (TCP/UDP) in .NET Core and .NET 5.",
        "Replaced old ASP classic Marketing UI with .NET Core and Angular web application.",
        "Improved system wide performance by introducing Redis and MongoDB to the on premises technology stack. Defined hardware specs for servers. Administered Linux servers, installed software in high availability configuration.",
        {
          DevOps: [
            "Integrated Azure Repos and GitHub as sources for TeamCity.",
            "Defined team’s branching strategy and CI/CD processes.",
            "Configured and maintained build agents for .NET Framework, .NET Core, Node",
            "Configured custom Linux build servers for proprietary software written in C/C++ utilizing ffmpeg and lib265.",
            "Wrote custom PowerShell scripts to automate deployments, start/stop services and send Microsoft Teams messages using webhooks.",
          ],
        },
      ],
      start: "",
      end: "",
    },
    {
      company: "Experian Healthcare",
      position: "Software Developer III",
      descriptoin: "",
      list: ["Software Developer III experience"],
      start: "",
      end: "",
    },
    {
      company: "Experian Healthcare",
      position: "Software Developer II",
      descriptoin: "",
      list: ["Software Developer II experience"],
      start: "",
      end: "",
    },
    {
      company: "Experian Healthcare",
      position: "Software Developer I",
      descriptoin: "",
      list: ["Software Developer I experience"],
      start: "",
      end: "",
    },
    {
      company: "Buzzbox Media",
      position: "Junior Web Developer",
      descriptoin: "",
      list: ["Junior Web Developer I experience"],
      start: "",
      end: "",
    },
  ];
  useEffect(() => {
    let grps = Object.groupBy(data, ({ company }) => company);
    setExperience(grps);
  }, []);

  return (
    <div>
      <div className="michroma-regular" style={{ textAlign: "center" }}>
        Experience
      </div>

      {Object.keys(experience).map((key) => {
        return (
          <CompanyExperience company={key} experiences={experience[key]} />
        );
      })}
    </div>
  );
}

function CompanyExperience({ company, experiences }) {
  return (
    <>
      <p style={{ fontFamily: "Space Mono" }}>{company}</p>
      <Timeline
        sx={{
          [`& .${timelineItemClasses.root}:before`]: {
            flex: 0,
            padding: 0,
          },
        }}
      >
        {experiences.map((exp) => {
          return (
            <TimelineItem>
              <TimelineSeparator>
                <TimelineDot />
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent>
                <Typography
                  variant="h6"
                  component="span"
                  sx={{ fontFamily: "Space Mono" }}
                >
                  {exp.position}
                </Typography>
                {exp.description && (
                  <Typography sx={{ fontFamily: "Space Mono" }}>
                    {exp.description}
                  </Typography>
                )}
                {exp.list && exp.list.length > 0 && (
                  <ExperienceList list={exp.list} />
                )}
              </TimelineContent>
            </TimelineItem>
          );
        })}
      </Timeline>
      <Divider sx={{ borderColor: "white", opacity: 0.2 }} />
    </>
  );
}

function ExperienceList({ list }) {
  if (Array.isArray(list))
    return (
      <ul>
        {list.map((l) => (
          <li style={{ fontFamily: "Space Mono" }}>
            <ExperienceList list={l} />
          </li>
        ))}
      </ul>
    );

  if (typeof list === "object" && list != null) {
    let items = [];
    for (const key in list) {
      items.push(
        <>
          {key}
          <ul>
            {list[key].map((v) => (
              <li style={{ fontFamily: "Space Mono" }}>{v}</li>
            ))}
          </ul>
        </>
      );
    }

    // primitive type
    return items.map((i) => i);
  }

  return list;
}
